import React from 'react';
import { ReactComponent as SVGDoc } from './edwards-logo.svg';

export const EdwardsLogoIcon: React.FunctionComponent = function EdwardsLogoIcon() {
  return <SVGDoc width="140px" height="24px" />;
};
